<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>CADASTRAR MOVIMENTAÇÃO</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">

      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Valor" name="price" v-model.lazy="price" v-money="money" class="mt-5 w-full" />
        <vs-select v-model="movimento" label="Movimento" class="mt-5 w-full" autocomplete>
          <vs-select-item :key="item.id" :value="item.value" :text="item.text" v-for="item in movimentos"  />
        </vs-select>
        <vs-select v-model="franquia" label="Franquia" class="mt-5 w-full" autocomplete>
          <vs-select-item :key="item.id" :value="item.id" :text="getnomefranquia(item)" v-for="item in category_choices"  />
        </vs-select>

        <vs-input label="Nota" name="obs" v-model="obs" class="mt-5 w-full" />


        <!-- CATEGORY -->


      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center p-6" slot="footer">
      <vs-button class="mr-6" @click=cadastrarConta :disabled='isDisabled'>Cadastrar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {VMoney} from 'v-money'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {

      movimento: '',
      price: '',
      franquia: '',
      obs: '',

      repetir_senha: '',
  	  nota: '',
  	  conta: '',
      franquia: '',
      banco: '001',
      tipo_conta: '01',
      price: '',
  	  terms: true,
      money: {
  			decimal: ',',
  			thousands: '.',
  			prefix: 'R$ ',
  			suffix: '',
  			precision: 2,
  			masked: false /* doesn't work with directive */
  		},
  	  tipo: '1',

      category_choices: [],
      movimentos: [
        {text:'Crédito',value:'Crédito'},
        {text:'Débito',value:'Débito'},
        {text:'Chargeback',value:'Chargeback'},
        {text:'Pagamento',value:'Pagamento'},
        {text:'Estorno de Pagamento',value:'Estorno de Pagamento'}
      ],
      settings: { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed: .60,
      },
    }
  },
  computed: {
	isDisabled: function(){
    	return !this.terms;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if(!val) {
          this.$emit('closeSidebar');
          this.initValues();
        }
      }
    }
  },
  methods: {
    initValues() {
      this.name = '';
      this.category = 'audio';
      this.order_status = 'pending';
      this.price = '';
      this.$refs.fileUpload.srcs = [];
    },
    getnomefranquia(franquia) {
      return franquia.nome_franquia + ' - ' + franquia.cnpj;
    },
    cadastrarConta() {



		this.terms = false;
		fetch(this.$store.state.API_URL + 'Admin/Cadastro/Movimento', {
			method: 'POST',
			headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
			body: "token="+localStorage.getItem("token")+"&movimento="+this.movimento+"&price="+this.price+"&franquia="+this.franquia+"&obs="+this.obs
		})
		.then((response) => response.text())
		.then((responseData) => {

			var dados = JSON.parse(responseData);
			if(dados.done == true)
			{
				this.$vs.notify({
					title: 'SPSaude',
					text: dados.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				});
				this.terms = true;
				this.$router.go();
			}
			else
			{
				this.$vs.notify({
					title: 'SPSaude',
					text: dados.message,
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger'
				});
				this.terms = true;
			}
		});
    }
  },
  created() {
    const thisIns = this;
    fetch(this.$store.state.API_URL + 'Info/Franquias', {
		method: 'POST',
		headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
		body: "token="+localStorage.getItem("token")
	})
	.then((response) => response.text())
	.then((responseData) => {
		var dados = JSON.parse(responseData);
		thisIns.category_choices = dados.franquias;
		//thisIns.dadosx = dados.meus_dados;

	});
  },
  components: {
    VuePerfectScrollbar,
  },
  directives: {money: VMoney}
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>
